import { MapPin, Phone, Mail } from "lucide-react";

export const Footer = () => (
  <footer className="bg-emerald-950 text-emerald-100/70 mt-24" data-testid="footer">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 py-14 grid gap-10 md:grid-cols-3">
      <div>
        <div className="flex items-center gap-2.5 text-white">
          <span className="h-9 w-9 rounded-xl overflow-hidden">
            <img src="/logo.png" alt="Accurate Auto Rentals logo" className="h-full w-full object-cover scale-[1.18]" />
          </span>
          <span className="font-display font-extrabold text-lg">Accurate Auto Rentals</span>
        </div>
        <p className="mt-4 text-sm max-w-xs leading-relaxed">
          Premium vehicle rentals with doorstep delivery, zero hidden fees and instant secure checkout — serving Greater Boston.
        </p>
      </div>
      <div className="text-sm space-y-2">
        <p className="text-white font-semibold mb-3">Company</p>
        <p>24/7 Concierge Support</p>
        <p>Doorstep Delivery</p>
        <p>Zero Hidden Fees</p>
        <p>Full Insurance Options</p>
      </div>
      <div className="text-sm space-y-3">
        <p className="text-white font-semibold mb-1">Visit Us — Boston, MA</p>
        <a href="https://maps.google.com/?q=1600+Blue+Hill+Ave+Mattapan+MA+02126" target="_blank" rel="noopener noreferrer" className="flex items-start gap-2.5 hover:text-emerald-300 transition-colors" data-testid="footer-address">
          <MapPin size={16} className="mt-0.5 shrink-0 text-emerald-400" />
          <span>1600 Blue Hill Ave (Rear)<br />Mattapan, MA 02126</span>
        </a>
        <a href="tel:+17815358932" className="flex items-center gap-2.5 hover:text-emerald-300 transition-colors" data-testid="footer-phone">
          <Phone size={16} className="shrink-0 text-emerald-400" />
          <span>781-535-8932</span>
        </a>
        <a href="mailto:Accurateautosolutions1@gmail.com" className="flex items-center gap-2.5 hover:text-emerald-300 transition-colors" data-testid="footer-email">
          <Mail size={16} className="shrink-0 text-emerald-400" />
          <span>Accurateautosolutions1@gmail.com</span>
        </a>
      </div>
    </div>
    <div className="border-t border-emerald-800/50 py-5 text-center text-xs text-emerald-100/50">
      © {new Date().getFullYear()} Accurate Auto Rentals · Boston, MA. All rights reserved.
    </div>
  </footer>
);
